module.exports = __webpack_public_path__ + "assets/13db00b7a34fee4d819ab7f9838cc428.eot";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/semantic/themes/default/assets/fonts/brand-icons.eot
// module id = 1509
// module chunks = 0